import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Galerie from "@/pages/Galerie";
import Admin from "@/pages/Admin";
import LeStudio from "@/pages/LeStudio";
import Prestations from "@/pages/Prestations";
import PrestationDetail from "@/pages/PrestationDetail";
import Contact from "@/pages/Contact";
import { LangProvider } from "@/i18n";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#050505] text-white min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <LangProvider>
        <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/le-studio" element={<LeStudio />} />
          <Route path="/prestations" element={<Prestations />} />
          <Route path="/prestations/:slug" element={<PrestationDetail />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <ChatWidget />
        </BrowserRouter>
      </LangProvider>
      <Toaster theme="dark" position="bottom-right" toastOptions={{
        style: { background: "#121212", border: "1px solid rgba(212,175,55,0.4)", color: "#fff" },
      }} />
    </div>
  );
}

export default App;
